
import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase'
import ProductFinding from '@/store/entities/baseInfo/ProductFinding';
import ProductFindingReply from '@/store/entities/baseInfo/ProductFindingReply';

@Component
export default class extends AbpBase {
    @Prop({type: Object, default:()=>{return null;}}) finding: ProductFinding;

    name: string= 'product-finding-breadcrumb';

    itemTitle (item: any) {
        return this.L(item.meta.title);
    }
}
